// export this package's api
import Align from './Align';

export default Align;


//////////////////
// WEBPACK FOOTER
// ./~/rc-align/es/index.js
// module id = 1100
// module chunks = 0 1